import { bigdataRequest } from './axios'
import qs from 'qs'

const baseUrl = '/v1/api/searchKey/'

export default {
  page(data) {
    return bigdataRequest.get(baseUrl + 'page', { params: data }).then(res => res.data)
  },
  shopList() {
    return bigdataRequest.get(baseUrl + 'shopList').then(res => res.data)
  },
  save(data) {
    return bigdataRequest.post(baseUrl + 'save', qs.stringify(data), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(res => res.data)
  },
  delete(id) {
    return bigdataRequest.post(baseUrl + 'delete', qs.stringify({ id }), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(res => res.data)
  },
  upload(formData) {
    return bigdataRequest.post(baseUrl + 'upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data)
  },
  switchSourceType(id, sourceType) {
    return bigdataRequest.post(baseUrl + 'switchSourceType', qs.stringify({ id, sourceType }), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(res => res.data)
  }
}
